import React, { useEffect, useState, useRef } from "react";
import * as API from "../../helpers/api";
import config from "../../config";
import Loading from "react-loader-spinner";
import { useLang } from "../../helpers/language";
import parse from "html-react-parser";

import { Link } from "react-router-dom";
import useScroll from "../../assets/hooks/useScroll";
import useWindowSize from "../../assets/hooks/useWindowSize";
import "./bottle-types.scss";
import { withLanguage, withDictionary } from "../../assets/js/contexts";

const BottleTypes = ({ dictionary }) => {
  const container = useRef(null);
  const [offset, setOffset] = useState(0);
  const [bottles, setBottles] = useState([]);
  const [beerPage, setBeerPage] = useState([]);
  const { lang } = useLang();
  const [isBusy, setBusy] = useState(true);
  const scroll = useScroll();
  const { width } = useWindowSize();

  useEffect(() => {
    (async () => {
      setBusy(false);
      if (!container || width < 576) {
        return;
      }
      const height = container.current.getBoundingClientRect().height;
      const offsetTop = container.current.offsetTop + height / 3;
      setOffset((offsetTop - scroll) / 20);
    })();
  }, [scroll, container, width]);

  useEffect(() => {
    (async () => {
      let rawBottles = await API.get(
        config.api.beer,
        { [`countries.${localStorage.country}`]: true },
        {},
        true
      );
      setBottles(rawBottles);

      let rawBeerPage = await API.get(config.api.beerPage);
      setBeerPage(rawBeerPage && rawBeerPage[0]);
    })();
  }, [isBusy]);

  if (isBusy) return <Loading type="Oval" color="#FFBE03" className="loader" />;
  else
    return (
      <div id="bottle-types" ref={container}>
        <div className="container">
          <div className="row">
            <div className="col-sm-4">
              <h3>
                {beerPage?.title
                  ? beerPage?.title[lang]
                    ? beerPage?.title[lang]
                    : ""
                  : ""}
              </h3>
            </div>
            <div className="col-sm-8">
              <div className="description">
                {parse(beerPage?.desc ? beerPage?.desc[lang] : "")}
              </div>
            </div>
          </div>
        </div>
        <div className="bottles">
          <div style={{ transform: `translate3d(${offset}%, 0, 1px)` }}>
            {bottles.map((bottle, index) => (
              <Link to={`/beer/${bottle._id}`} key={index}>
                <img
                  src={`${config.api.API_URL}/${
                    bottle?.uploads && bottle?.uploads[0].path
                  }`}
                  width="117px"
                  alt=""
                />
              </Link>
            ))}
          </div>
        </div>
      </div>
    );
};

export default withLanguage(withDictionary(BottleTypes));
